import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { Box, Button } from '@mui/material';
import { Colors } from '../assets/theme/Colors';

const ButtonWithLoading = props => {
  const { isLoading = false, disabled = false, color = 'primary', fullWidth, children, ...rest } = props;

  return (
    <Box sx={[{ display: 'flex' }, fullWidth && { width: '100%' }]}>
      <Box sx={[{ position: 'relative' }, fullWidth && { width: '100%' }]}>
        <Button variant="contained" fullWidth={fullWidth} color={color} disabled={isLoading || disabled} {...rest}>
          {children}
        </Button>
        {isLoading && (
          <CircularProgress
            size={24}
            sx={{
              color: Colors.appBar.main,
              position: 'absolute',
              top: '50%',
              left: '50%',
              marginTop: '-12px',
              marginLeft: '-12px',
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default ButtonWithLoading;
